import { useEffect, useState } from 'react';

import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import ActionButton from '../../../elements/action-button/ActionButton';
import TextInput from '../../../elements/text-input/TextInput';
import Modal from '../../../sections/modal/Modal';
import { StyledModalButtonsWrapper } from '../styles';

const EditQueryNameButton = ({ onEditQueryName, query }) => {
  const { t } = useTranslation();

  const [modal, setModal] = useState(false);
  const toggleEditModal = () => setModal(!modal);

  const { name } = query;

  const {
    control,
    watch,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm({ defaultValues: { newQueryName: name } });

  useEffect(() => {
    if (!modal) return;
    setValue('newQueryName', name);
  }, [modal]);

  const handleEditQueryName = async (form) => {
    const { newQueryName } = form;
    const payload = {
      name: newQueryName,
      collection: query.collection,
      settings: query.settings,
    };

    await onEditQueryName(query.id, payload);
    toggleEditModal();
  };

  return (
    <>
      <Tooltip
        placement="bottom"
        title={t('editQueryName', { ns: 'sectionTitles' })}
      >
        <IconButton size="large" onClick={toggleEditModal}>
          <EditIcon />
        </IconButton>
      </Tooltip>
      <Modal
        title={t('editQueryName', { ns: 'sectionTitles' })}
        openModal={modal}
        handleClose={toggleEditModal}
      >
        <Typography sx={{ mb: 3 }}>
          {t('editQueryName', { ns: 'descriptions' })}
        </Typography>
        <TextInput
          name="newQueryName"
          label={t('queryName', { ns: 'fields' })}
          autoFocus
          control={control}
          errors={errors}
          defaultValue={name}
        />
        <StyledModalButtonsWrapper>
          <Button variant="text" onClick={toggleEditModal} color="inherit">
            {t('cancel', { ns: 'buttons' })}
          </Button>
          <ActionButton
            clickAction={handleSubmit(handleEditQueryName)}
            disabled={
              watch('newQueryName') === name || watch('newQueryName') === ''
            }
          >
            {t('save', { ns: 'buttons' })}
          </ActionButton>
        </StyledModalButtonsWrapper>
      </Modal>
    </>
  );
};

EditQueryNameButton.propTypes = {
  onEditQueryName: PropTypes.func.isRequired,
  query: PropTypes.object.isRequired,
};

export default EditQueryNameButton;
